import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { IRequiredReportFields } from '../interfaces/irequired-report-fields';
import { IReportSearch } from '../interfaces/ireport-search';
import { ReportService } from '@core/services/report.service';
import { take } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationModalComponent } from '@shared/components/confirmation-modal/confirmation-modal.component';
import { ActivatedRoute } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'drdp-state-group-detail',
    templateUrl: './state-group-detail.component.html',
    styleUrls: ['./state-group-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StateGroupDetailComponent {
  requiredFields: IRequiredReportFields = {
    state: true,
    agency: false,
    globalRatingPeriod: true,
    site: false,
    classroom: false,
    ageGroup: true,
    requireMultipleRatingPeriods: false
  };

  reportService = inject(ReportService); 
  dialog = inject(MatDialog);
  route = inject(ActivatedRoute);
  private translocoService = inject(TranslocoService);
  is2025: boolean = false;
  title: string = '';

  ngOnInit(): void {
    this.is2025 = this.route.snapshot.data['is2025'] ?? false;
    this.title = this.translocoService.translate('reports.stateGroupDetail.title', { year: this.is2025 ? '2025' : '2015' });
  }

  showReport(searchValue: IReportSearch): void {
    const service = (payload: IReportSearch) => this.is2025 
      ? this.reportService.saveStateGroupDetailRequest2025(payload)
      : this.reportService.saveStateGroupDetailRequest(payload);
    
    service(searchValue)
      .pipe(take(1))
      .subscribe((res: boolean) => {
        if (res) this.displaySuccessMessage();
      });
  }

  displaySuccessMessage(): void {
    const modal = {
      data: {
        modalInfo: {
          title: this.translocoService.translate('reports.requestSubmitted.title'),
          message: this.translocoService.translate('reports.requestSubmitted.message'),
          primaryBtnClass: 'blue',
          primaryBtnText: this.translocoService.translate('reports.requestSubmitted.confirm'),
          showCancel: false,
        },
      },
    };
    this.dialog.open(ConfirmationModalComponent, { data: modal });  
  }
}
